export var CombinedRole;
(function (CombinedRole) {
    CombinedRole["AGENCY"] = "AGENCY";
    CombinedRole["PUBLISHER"] = "PUBLISHER";
    CombinedRole["YALEO_SELF_BOOKING_USER"] = "YALEO_SELF_BOOKING_USER";
})(CombinedRole || (CombinedRole = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["TOKEN"] = "token";
})(StorageKey || (StorageKey = {}));
